<template>
    <div class="focused-well-left-panel-top">
        <left-panel-well-details :focused-well="well" />

        <div v-if="!isFdaFriendly" class="key-score-metrics">
            <well-rank :well="well" />

            <kid-score
                option="focused-well-option"
                :well="well"
                :only-background-high-score="true"
            />

            <blast-score
                option="focused-well-option"
                :well="well"
                :only-background-high-score="false"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LeftPanelWellDetails from './LeftPanelWellDetails'
import WellRank from './common/WellRank'
import KidScore from './score-metrics/KidScore'
import BlastScore from './score-metrics/BlastScore'

export default {
    name: 'FocusedWellLeftPanelTop',
    components: {
        LeftPanelWellDetails,
        WellRank,
        KidScore,
        BlastScore
    },
    props: {
        well: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly'
        })
    }
}
</script>

<style lang="scss" scoped>
.focused-well-left-panel-top {
    background-color: $dark-3;
    border-radius: $border-radius-lg;

    .key-score-metrics {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        column-gap: 10px;
    }

    @media screen and #{$new-break3} {
        display: flex;
        flex-direction: column-reverse;
        margin: 0.5rem;
        padding: 0;

        .key-score-metrics {
            height: 90px;
        }
    }

    @media screen and #{$new-break4open} {
        padding: 0.5rem 0.5rem 1rem;
    }

    @media screen and #{$new-break4} {
        .key-score-metrics {
            grid-template-columns: 1fr;
            grid-template-rows: repeat(3, 1fr);
            row-gap: 10px;
        }
    }
}
</style>
